'use client';

import { useLocation, useNavigate } from 'react-router';
import { Home, Gavel, ShoppingBag, Ticket, User, GraduationCap, Leaf } from 'lucide-react';
import { asetquLandEnabled } from '@/lib/features';

const NAV_ITEMS = [
  { id: '/', label: 'HOME', icon: Home },
  { id: '/propribid', label: 'PROPRIBID', icon: Gavel },
  { id: '/proprimarket', label: 'PROPRIMARKET', icon: ShoppingBag },
  { id: '/proprivoucher', label: 'PROPRIVOUCHER', icon: Ticket },
  ...(asetquLandEnabled ? [{ id: '/asetqu-land', label: 'AsetQu LAND', icon: Leaf }] : []),
  { id: '/academy', label: 'ACADEMY', icon: GraduationCap },
  { id: '/profile', label: 'PROFILE', icon: User },
];

const getActiveLabel = (label: string) => {
  if (label === 'AsetQu LAND') return 'LAND';
  if (label === 'HOME') return 'HOME';

  return label.replace('PROPRI', '');
};

const BottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location.pathname;

  const activeItem =
    NAV_ITEMS.find(item =>
      item.id === '/'
        ? pathname === '/'
        : pathname.startsWith(item.id) ||
          (item.id === '/asetqu-land' && pathname.startsWith('/my-asetqu-land'))
    ) || NAV_ITEMS[0];
  const inactiveItems = NAV_ITEMS.filter(item => item.id !== activeItem.id);

  return (
    <div className='w-full px-3 flex items-center justify-center gap-2'>
      <div className='flex shrink-0 items-center gap-2 bg-gradient-to-r from-teal-600 to-blue-800 text-white px-4 py-3.5 rounded-full shadow-lg shadow-blue-900/20 transition-all duration-500 ease-in-out'>
        <activeItem.icon size={20} strokeWidth={2.5} />
        <span className='text-[11px] font-bold tracking-wider uppercase whitespace-nowrap'>
          {getActiveLabel(activeItem.label)}
        </span>
      </div>

      <div
        className='min-w-0 flex-1 grid items-center bg-white/95 backdrop-blur-md rounded-full px-2 py-2.5 shadow-[0_4px_25px_rgba(0,0,0,0.06)] border border-gray-100/50'
        style={{ gridTemplateColumns: `repeat(${inactiveItems.length}, minmax(0, 1fr))` }}
      >
        {inactiveItems.map(item => (
          <button
            key={item.id}
            onClick={() => navigate(item.id)}
            className='mx-auto flex h-8 w-8 items-center justify-center text-gray-400 hover:text-blue-600 hover:bg-blue-50 transition-all duration-200 rounded-full'
            aria-label={item.label}
          >
            <item.icon size={19} strokeWidth={2} />
          </button>
        ))}
      </div>
    </div>
  );
};

export default BottomNav;
